import _ from 'lodash';
import styled from 'styled-components';
import React, { Component } from 'react';
import { Form, Icon, Message } from 'semantic-ui-react';

import { login } from '../../fetcher';
import { Redirect } from 'react-router-dom';
import { UserContext } from '../../context';
import { THEME_COLOR } from '../../config';

const ForgetPassword = styled.div`
	display: flex;
	width: 100%;
	justify-content: flex-end;
	position: absolute;

	> span {
		font-weight: 400;
		font-size: .9em;
		&:hover {
			text-decoration: underline;
			cursor: pointer;
		}
	}
`;

const ColorButton = styled.div`
	.ui.teal.buttons .button, .ui.teal.button {
		background-color: ${THEME_COLOR};
	}
`

class LoginSection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formStatus: false,
			formValue: {},
			isLoading: false,
			data: {username: "impuls", password: "password" }
		}

		this.handleSubmit = this.handleSubmit.bind(this)
		this.handleChange = this.handleChange.bind(this)
	}

	handleChange(e, props) {
		const { formValue } = this.state
			const { name, value } = props
			this.setState({formStatus: false})
			return this.setState({formValue: _.assign({}, formValue, { [name]: value })});
	}

	async handleSubmit() {
		this.setState({ isLoading: true })
		const {redirection} = this.props
		const session = this.context;
		const { formValue } = this.state;

		const response = await login(formValue);
		
		let formStatus = {};
		if (response.status_code === 200) {
			await session.checkUser();
			return <Redirect to={redirection !== ''?decodeURIComponent(redirection):'/test'} />;
		} else {
			formStatus = { status: 'error', props: {} }
			switch (response.message) {
				case "Username and Password combination is invalid": {
					formStatus.props = { error: true, size: 'tiny', header: 'Login Gagal', content: 'Kombinasi username dan password yang Anda masukan tidak sesuai' };
					break;
				}
				case "Account is disabled": {
					formStatus.props = { error: true, size: 'tiny', header: 'Login Gagal', content: 'Mohon maaf, saat ini akun Anda berstatus nonaktif, mohon hubungi Admin untuk mengaktifkannya' };
					break;
				}
				default:
			}
		}

		this.setState({ isLoading: false, formStatus })
	}
	
	render() {
		const { formValue, formStatus, isLoading } = this.state
		const { setStatus } = this.props

		const username = _.get(formValue, "username", "")
		const password = _.get(formValue, "password", "")
		
		const disabledButton = _.isEmpty(password) || _.isEmpty(username)
		return (<Form>
			<Form.Field required>
				<label style={{color: THEME_COLOR}}>Username</label>
				<Form.Input disabled={isLoading} name="username" placeholder='Masukkan username unik Anda' value={username} onChange={this.handleChange}/>
			</Form.Field>
			<Form.Field required>
				{/* <ForgetPassword style={{ fontWeight: '400', color: "black" }}><span onClick={() => setStatus("FORGET")}>Lupa Password ?</span></ForgetPassword> */}
				<label style={{color: THEME_COLOR}}>Password</label>
				<Form.Input disabled={isLoading} name="password" type="password" placeholder='Masukkan password / kata sandi akun Anda' value={password} onChange={this.handleChange}/>
			</Form.Field>
			{_.get(formStatus, "props.error", false) && <div style={{marginBottom: "1em"}}><Message negative {..._.omit(_.get(formStatus, "props", {}), ["error"])} /></div>}
			<ColorButton>
				<Form.Button color="teal" type="submit" floated="right" disabled={disabledButton || isLoading} loading={isLoading} onClick={this.handleSubmit}>Masuk <Icon name="arrow right" /></Form.Button>
			</ColorButton>
		</Form>);
	};
};

LoginSection.contextType = UserContext;

export default LoginSection;